// extracted by mini-css-extract-plugin
module.exports = {"list-photos":"list-photos","listPhotos":"list-photos","photo-item":"photo-item","photoItem":"photo-item"};